import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
} from "@mui/material/styles";
import { useEffect } from "react";
import { useAdminDetails, useWhiteLabelCode } from "@/v2/stores";

import { resolveAppTheme } from "./appTheme";

// MUI theme for old UI compatibility (makeStyles, withStyles)
const muiTheme = createTheme({
  palette: {
    background: {
      paper: "#fff",
    },
  },
});

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const whiteLabelCode = useWhiteLabelCode();
  const adminDetails = useAdminDetails();

  // Super admins can override whitelabel via localStorage (preview mode)
  const isSuperAdmin =
    adminDetails?.cityId === null && adminDetails?.whiteLabelId === null;

  let effectiveWhitelabel = whiteLabelCode;
  if (typeof window !== "undefined" && isSuperAdmin) {
    try {
      const stored = localStorage.getItem("whitelabelName");
      if (stored) {
        effectiveWhitelabel = JSON.parse(stored);
      }
    } catch {
      // Parse error - use default whitelabel
    }
  }

  const themeName = resolveAppTheme(effectiveWhitelabel);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", themeName);
  }, [themeName]);

  // Wrap with MUI ThemeProvider for old UI components using makeStyles
  return <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>;
};

export const useAppTheme = (): string => {
  const whiteLabelCode = useWhiteLabelCode();
  const adminDetails = useAdminDetails();

  // Super admins can override whitelabel via localStorage (preview mode)
  const isSuperAdmin =
    adminDetails?.cityId === null && adminDetails?.whiteLabelId === null;

  let effectiveWhitelabel = whiteLabelCode;
  if (typeof window !== "undefined" && isSuperAdmin) {
    try {
      const stored = localStorage.getItem("whitelabelName");
      if (stored) {
        effectiveWhitelabel = JSON.parse(stored);
      }
    } catch {
      // Parse error - use default whitelabel
    }
  }

  return resolveAppTheme(effectiveWhitelabel);
};
